import type { AppState } from '@store/types'
import { useSelector } from 'react-redux'

import {
  getActiveBgColor,
  getActiveContent,
  getActiveFont,
  getActivePreset,
} from '../helper/getActiveValues'

export const useGetActives = () => {
  const publishData = useSelector(({ publish }: AppState) => publish) // TODO: check types

  const activePreset = getActivePreset(publishData)

  const activeFont = getActiveFont(publishData)

  const activeContent = getActiveContent(publishData)

  const activeBgColor = getActiveBgColor(publishData)

  return {
    publishData,
    activePreset,
    activeFont,
    activeBgColor,
    activeContent,
  }
}
